import { InfoHeader } from "./InfoHeader";
export default InfoHeader;
